    <div class="row">
        <div class="col-1">
            <img src="../../../../../assets//images/ace-standard-logo-100px.png" class="aceLogo">
        </div>
        <div class="col-10 text-center">
            <span class="companyHeader">{{invoiceHeaderForDisplay.aceCompanyName}}</span><br />
            <span class="addressText" *ngFor="let lotData of lotAddressHeaderArray">
                {{lotData}}<br />
            </span>
        </div>
        <div class="col-1"></div>
    </div>

    <div class="row" style="margin-top:20px;">
        <div class="col-8">
            <span class="addressHeader" style="font-weight: bold;">{{invoiceHeaderForDisplay.customerName}}</span><br />
            <span class="addressText" *ngFor="let customerData of customerAddressHeaderArray">
                {{customerData}}<br />
            </span>
        </div>
        <div class="col-4" style="border: 1px black solid">
            <div class="row" style="margin-top:10px;">
                <div class="col-6 text-end">
                    Invoice Number: 
                </div>
                 <div class="col-6">
                    {{invoiceHeaderForDisplay.invoiceNumber}}
                </div>
                <div class="col-6 text-end">
                    Invoice Date: 
                </div>
                 <div class="col-6">
                    {{invoiceHeaderForDisplay.invoiceDate | date:'shortDate'}}
                </div>
                 <div class="col-6 text-end">
                    <strong>Due Date: </strong>
                </div>
                 <div class="col-6">
                    <strong>{{invoiceHeaderForDisplay.dueDate | date:'shortDate'}}</strong>
                </div>
                 <div class="col-6 text-end">
                    Total Balance: 
                </div>
                 <div class="col-6">
                    {{invoiceHeaderForDisplay.totalBalance| currency}}
                </div>
            </div>
        </div>
    </div>







